import callIfArgumentsPass from "../../../utils/callIfArgumentsPass";
import curry from "../../../lib/core/functional/curry";
import renderView from "./module";
import { getUserTransport, getSiteId } from "../_common";
import { getLazyEditor } from "../../../editor/loader";

function didAboutChanged(oldProfileSite, profileSite) {
    return profileSite.about_html !== oldProfileSite.about_html;
}

export const renderEditAbout = curry(function renderEditAbout(
    renderWithProps,
    editorLoader,
    userTransport,
    profileSite
) {
    function saveSiteAbout(about_html) {
        userTransport.sendChanges({ about_html });
    }

    return renderWithProps({
        saveSiteAbout,
        editor: editorLoader({ initialContent: profileSite.about_html, enableLinks: true }),
    });
});

const onTransport = curry(function onTransport(element, [editorLoader, userTransport]) {
    userTransport.subscribeToChanges(
        callIfArgumentsPass(
            didAboutChanged,
            renderEditAbout(renderView(element), editorLoader, userTransport)
        )
    );
});

export default function renderer(context, element) {
    const siteId = getSiteId(context, element);
    if (!siteId) {
        return;
    }

    Promise.all([getLazyEditor(), getUserTransport(context, siteId)])
        .then(onTransport(element))
        .catch(console.error);
}
